import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Home, ArrowLeft, Search } from 'lucide-react';

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center p-4 pt-20">
      <div className="glass-default rounded-2xl p-8 md:p-12 max-w-lg text-center">
        <div className="text-8xl font-bold gradient-text mb-4">404</div>
        <h1 className="text-2xl md:text-3xl font-bold mb-2">Page Not Found</h1>
        <p className="text-white/60 mb-8">
          Sorry, the page you&apos;re looking for doesn&apos;t exist or has been moved.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button 
            onClick={() => navigate(-1)} 
            variant="outline" 
            className="border-white/20 hover:bg-white/10"
          >
            <ArrowLeft size={18} className="mr-2" />
            Go Back
          </Button>
          <Button 
            onClick={() => navigate('/')} 
            className="bg-violet-600 hover:bg-violet-500"
          >
            <Home size={18} className="mr-2" />
            Home Page
          </Button>
          <Button 
            onClick={() => navigate('/browse')} 
            variant="outline"
            className="border-white/20 hover:bg-white/10"
          >
            <Search size={18} className="mr-2" />
            Browse Artists
          </Button>
        </div>
      </div>
    </div>
  );
}
